import { ValidationError } from 'yup';
import { convertArrayToObject } from '../array';

export default function validate<Errors>(schema, values) {
  try {
    schema.validateSync(values, { abortEarly: false });
  } catch (error) {
    if (error instanceof ValidationError) {
      const errorsAsArray = error.inner.map(({ path, message }) => ({ path, value: message }));
      const errors = convertArrayToObject<Errors>(errorsAsArray);

      return errors;
    }
  }
}
